<template>
  <div class="text-base">
    <div v-if="status" class="heading heading--sm mb-2 mt-6">{{ $t(`${status}`) }}</div>

    <table class="b2b-grid b2b-grid--collapse is-compact" qaid="order-details-sku-grid">
      <caption class="sr-only">
        {{
          $t('text.shipments')
        }}
      </caption>
      <thead class="b2b-grid__header">
        <th
          v-for="header in getHeaders()"
          :key="header.label"
          class="b2b-grid__cell b2b-grid__head"
          :class="[{'whitespace-nowrap': header.key !== 'etaDate'}, header.cssClasses]"
          :data-type="header.key === 'etaDate' ? 'eta-date' : false"
        >
          {{ header.label }}
        </th>
      </thead>

      <tbody>
        <template v-for="item in paginatedData" :key="generateItemKey(item)">
          <account-order-details-shipment-item :item="item" :selectable="false" />
        </template>
      </tbody>
    </table>

    <div class="grid-x grid-margin-x mb-5">
      <div class="cell medium-6 large-8">
        <pagination-controls
          v-if="pageCount > 1"
          ref="pagination"
          :page-number="pageNumber"
          :page-count="pageCount"
          @page-change="pageChange"
          @prev-page="prevPage"
          @next-page="nextPage"
        />
      </div>
      <div v-if="!isConsumerFriendlyMode" class="cell medium-6 large-4">
        <div v-cloak class="block-list text-base">
          <div class="block-list__item w-full" qaid="order.shipment.subtotal">
            <span>{{ $t('text.order.subtotal') }}</span>
            <span>{{ subtotal }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from '../../mixins/pagination';
import {mapState} from 'vuex';
export default {
  mixins: [pagination],
  inject: ['container'],
  provide() {
    return {
      headers: this.headers,
    };
  },
  props: {
    size: {
      type: Number,
      required: false,
      default: ACC.allocatedItemsPageSize || 50,
    },
    items: {
      type: Array,
      default: () => [],
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    index: {
      type: Number,
      default: 0,
    },
    status: {
      type: String,
      default: '',
    },
    subtotal: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      listData: this.items,
    };
  },
  computed: {
    ...mapState('backend', ['isConsumerFriendlyMode']),
  },
  methods: {
    getHeaders() {
      return this.headers.filter((header) => {
        return !(this.isConsumerFriendlyMode && (header.key === 'unitPrice' || header.key === 'lineSubtotal'));
      });
    },
    generateItemKey(item) {
      return `${item.sku}-${crypto.randomUUID()}`;
    },
  },
};
</script>
